import React from 'react';
import {FooterWrapper, PageWrapper, RightPart} from './styles';
import {LoginForm} from './LoginForm';
import {useLoginRes} from '../../hooks/auth';
import {LogoSection} from './LogoSection';

type LogInPropsT = {
  authData: useLoginRes;
  successUpdated?: boolean;
};

export const LogInPage: React.FC<LogInPropsT> = ({authData, successUpdated}) => {
  return (
    <PageWrapper>
      <LogoSection />
      <RightPart>
        <LoginForm authData={authData} successUpdated={successUpdated} />
        <FooterWrapper showFootNote />
      </RightPart>
    </PageWrapper>
  );
};
